import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { Participant } from '../types';

export const getDisplayName = (
  participant: Partial<Omit<Participant, 'widget'>>,
  showDeactivated = true
) => {
  if (!participant) {
    return '';
  }
  const name =
    participant.fullName ||
    `${participant.firstName || ''} ${participant.lastName || ''}`.trim() ||
    participant.email?.trim() ||
    '';

  return participant.deletedAt && showDeactivated ? `${name} ${t('dr_deactivated')}` : name;
};
